
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
    styleUrls: ['./DisabledObjectsReport.css'],
    selector: 'DisabledObjectsReport',
    templateUrl: './DisabledObjectsReport.component.html',
})
export class DisabledObjectsReportComponent extends PageBase {
    constructor(el: ElementRef) {
        super(el, "DisabledObjectsReport");
    }
}
